function getChequingProductShape(product, isSponsoredTable) {
    return {
        id: product.ids?.primary,
        name: product.name,
        slug: product.slug,
        provider: {
            name: product.provider?.name,
            logo: product.provider?.logo,
        },

        detailsURL: product.urls?.details,
        applyURL: product.urls?.apply_redirect,

        monthlyCost: product.calculated_costs?.monthly_total,
        interest: product.calculated_interest ?? 0,

        availableFeatures: getAvailableFeatures(product.monthly_transactions, product.additional_features),
        waysToBank: getWaysToBank(product.ways_to_bank),

        type: product.type,
        eligibility: product.eligibility,
        promotions: getPromotions(product.promotional_offer),

        monthlyFee: product.calculated_costs?.monthly_fee,
        transactionFee: product.calculated_costs?.additional_fees,
        eTransferFee: product.monthly_transactions?.interac_e_transfer?.overage_fee ?? 0,

        isMonetized: product.monetized,
        // @TODO: Remove .sponsored after new deposits sponsored BE/CMS fully deployed
        isSponsored: (isSponsoredTable
            ? product.sponsored?.table
            : product.sponsored?.global)
            ?? product.sponsored,
        rank: product.rank,
        isPFAWinner: product.pfa_winner,
    };
}

function getAvailableFeatures(monthlyTransactions, additionalFeatures) {
    const transactionsObject = {
        selfServeTransactions: getTransactionNumber(monthlyTransactions?.self_serve?.atm_canada),
        tellerAssistedTransactions: getTransactionNumber(monthlyTransactions?.teller_assisted),
        chequeTransactions: getTransactionNumber(monthlyTransactions?.cheque),
        interacETransfers: getTransactionNumber(monthlyTransactions?.interac_e_transfer),
    };

    const additionalFeaturesObject = {
        additionalAccounts: additionalFeatures?.additional_accounts || null,

        rewards: additionalFeatures?.rewards || null,

        bankDrafts: additionalFeatures?.bank_drafts?.number || null,
        bankDraftCost: additionalFeatures?.bank_drafts?.fee || null,

        travellersCheques: additionalFeatures?.cheques?.travellers || null,
        personalizedCheques: additionalFeatures?.cheques?.personalized || null,

        creditCardRebate: additionalFeatures?.bonus_rebates?.credit_card || null,
        safetyDepositRebate: additionalFeatures?.bonus_rebates?.safety_deposit || null,

        overdraftFee: additionalFeatures?.overdraft?.fee || null,
        overdraftInterest: additionalFeatures?.overdraft?.interest || null,

        paperlessStatement: additionalFeatures?.statement_fees?.electronic || 'Free',
        mailedMonthlyStatement: additionalFeatures?.statement_fees?.mailed || 'Free',
    };

    // Note: Object order is preserved in 'more details' rows for product
    return {
        ...transactionsObject,
        monthlyTransactions: getMonthlyTransactionNumber(transactionsObject),
        ...additionalFeaturesObject,
    };
}

function getTransactionNumber(transaction) {
    // to get any non-null return, `transaction.available` must be true
    if (!transaction?.available) {
        return null;
    }

    return transaction.monthly_limit || 'Unlimited';
}

/**
 * Calculate monthly transactions by taking the highest transaction count
 * that isn't 'Unlimited'
 * @param {object} transactionsObject
 * @returns
 */
function getMonthlyTransactionNumber(transactionsObject) {
    const maxMonthlyTransactions = Math.max(
        ...Object.values(transactionsObject).filter(value => !!value && value !== 'Unlimited'),
    );

    return maxMonthlyTransactions !== Number.NEGATIVE_INFINITY ? maxMonthlyTransactions : 'Unlimited';
}

function getPromotions(promotions) {
    return promotions?.toLowerCase().includes('no promotions available') ? null : promotions;
}

function getWaysToBank(waysToBank) {
    return Object.keys(waysToBank).reduce((acc, curr) => {
        if (waysToBank[curr]?.available && WAYS_TO_BANK_MAP[curr]) {
            acc.push(WAYS_TO_BANK_MAP[curr]);
        }
        return acc;
    }, []);
}

const WAYS_TO_BANK_MAP = {
    mobile_app: 'mobileApp',
    in_branch: 'inBranch',
    online: 'onlineBanking',
    atm: 'ABM',
    telephone: 'telephoneBanking',
};

export default getChequingProductShape;
